module.exports = __webpack_public_path__ + "img/sfondo-prosciutto.29a30e9e.png";